"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var spin = (0, styled_components_1.keyframes)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  0% {\n    transform: rotate(0deg);\n  }\n\n  50% {\n    transform: rotate(235deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n"], ["\n  0% {\n    transform: rotate(0deg);\n  }\n\n  50% {\n    transform: rotate(235deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n"])));
var Sizes;

(function (Sizes) {
  Sizes[Sizes["small"] = 1.5] = "small";
  Sizes[Sizes["medium"] = 2.25] = "medium";
  Sizes[Sizes["large"] = 3] = "large";
})(Sizes || (Sizes = {}));

var makeSizeStyles = function makeSizeStyles(size, theme) {
  var _a, _b;

  return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  border-width: ", "rem;\n  height: ", ";\n  width: ", ";\n"], ["\n  border-width: ", "rem;\n  height: ", ";\n  width: ", ";\n"])), Sizes[size] / 16, (0, ui_symbols_1.calcSpace)(Sizes[size], (_a = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _a === void 0 ? void 0 : _a.STEP), (0, ui_symbols_1.calcSpace)(Sizes[size], (_b = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _b === void 0 ? void 0 : _b.STEP));
};

var Patterns = {
  primary: {
    color: 'BLUE["200"]',
    top: 'UTILITY.ACTION'
  },
  secondary: {
    color: 'GREY["200"]',
    top: 'GREY.DARK'
  },
  inverse: {
    top: 'GREY.WHITE'
  }
};

var makePatternStyles = function makePatternStyles(pattern) {
  if (pattern === 'inverse') {
    return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n      border-color: rgb(255, 255, 255, 0.2);\n      border-top-color: ", ";\n    "], ["\n      border-color: rgb(255, 255, 255, 0.2);\n      border-top-color: ", ";\n    "])), function (_a) {
      var theme = _a.theme;
      return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(Patterns[pattern].top), theme);
    });
  } else {
    return (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n      border-color: ", ";\n      border-top-color: ", ";\n    "], ["\n      border-color: ", ";\n      border-top-color: ", ";\n    "])), function (_a) {
      var theme = _a.theme;
      return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(Patterns[pattern].color), theme);
    }, function (_a) {
      var theme = _a.theme;
      return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(Patterns[pattern].top), theme);
    });
  }
};

exports.Root = styled_components_1.default.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['pattern', 'isAssertive', 'isPolite', 'theme'].includes(prop);
  }
})(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  animation: ", " 0.8s linear infinite;\n  border-radius: 50%;\n  border-style: solid;\n\n  ", "\n  ", "\n"], ["\n  animation: ", " 0.8s linear infinite;\n  border-radius: 50%;\n  border-style: solid;\n\n  ", "\n  ", "\n"])), spin, function (props) {
  return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'pattern', makePatternStyles);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'size', makeSizeStyles);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;